import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useKasutajaStore } from "./stores/kasutajaStore";
// import useInterval from './composables/useInterval';
import { onMounted, inject } from "vue";
import providerKeys from "./providerKeys";
import { KasutajaTeenus } from "./core/kasutaja-teenus";
import { AuthTeenus } from "./core/auth-teenus";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const authTeenus = new AuthTeenus();
const kasutajaTeenus = inject(providerKeys.kasutajaTeenus);

const kasutajaStore = useKasutajaStore();
// const interval = useInterval(annaKasutajaInfo)

async function annaKasutajaInfo() {
  try {
    const kasutaja = await (kasutajaTeenus as KasutajaTeenus).kasutajaInfo();
    kasutajaStore.satiKasutaja(kasutaja);
  } catch (ex) {
    console.error(ex);
    // interval.stop();
  }
}

onMounted(async () => {
  const onAuth = await authTeenus.kontrolliAuthi();
  if (onAuth?.isAuth) {
    await annaKasutajaInfo();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})